import { CheckBox, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const WatchlistLabelWrapper = styled.div`
  width: 105px;
`;

export const StyledDropdownWrapper = styled.div`
  position: fixed;
  top: 10px;
  left: 0;
  padding: 16px;
  min-width: max-content;

  & > div:not(:first-child) {
    padding-left: 16px;
  }
`;

export const IconWrapper = styled.div`
  position: relative;
`;

export const DropdownCheckbox = styled(CheckBox)`
  ${typographyV2.bodySm}

  label {
    font-size: 14px;
  }
`;
